import { IApplicationState } from '../../types/redux';
import { IDocumentSchema } from '../../repositories/newbuilding-card/entities/newbuilding/DocumentSchema';

export function getDocuments(state: IApplicationState): IDocumentSchema[] {
  const {
    newbuilding: { documentation },
  } = state;

  if (documentation && documentation.length) {
    return documentation;
  }

  return [];
}
